import React from "react";
import PropTypes from "prop-types";

import { Modal, Content, OptionClick, TextQuestion, ContainerAnswers } from "./styles";

const ModalQuestion = ({ modalVisible, setModalVisible, question, pressYes, pressNo }) => {
  return (
    modalVisible && (
      <Modal onClick={() => setModalVisible(false)}>
        <Content onClick={(event) => event.stopPropagation()}>
          <TextQuestion>¿{question}?</TextQuestion>
          <ContainerAnswers>
            <OptionClick onClick={pressYes}>Si</OptionClick>
            <OptionClick onClick={pressNo}>No</OptionClick>
          </ContainerAnswers>
        </Content>
      </Modal>
    )
  );
};

ModalQuestion.propTypes = {
  modalVisible: PropTypes.bool,
  setModalVisible: PropTypes.func,
  question: PropTypes.string,
  pressYes: PropTypes.func,
  pressNo: PropTypes.func,
};

export default ModalQuestion;
